/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import { config } from "../../../../../services/config";

export function BreadCrumbs({ items }) {
  if (!items || !items.length) {
    return "";
  }

  return (
    <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
      <li className="nav-icon-link">
        <Link to="/dashboard">
          <i
            //  className="flaticon2-shelter text-muted icon-1x"
            className="flaticon2-shelter icon-1x nav-icon"
            style={{ color: `${config.navBarTxtColor}` }}
          />
        </Link>
      </li>
      {items.map((item, index) => (
        <li key={`bc${index}`} className="breadcrumb-item-custom">
          <Link
            style={{ color: `${config.navBarTxtColor}` }}
            to={{ pathname: item.pathname }}
          >
            {"• " + item.title}
          </Link>
        </li>
      ))}
    </ul>
  );
}
